import React, {Component} from 'react';
import {histogram} from './histogram'
import HistogramPanel from './HistogramPanel'
import { nestedProp } from '../Utils/object';

export default class LinkQualityHistogram extends Component {
  constructor(props) {
    super(props);

    this.bins = [];
    this.onClick = this.onClick.bind(this)
  }
  linkQualityHistogramBins() {
    return [10, 20, 30, 40, 50, 60, 70, 80, 90];
  }
  linkQualityHistogramColors() {
    return ["#ff2c55", "#ff2c55", "#f57703", "#f57703", "#f1d900","#f1d900", "#0fc0a4", "#0fc0a4", "#0fc0a4"];
  }

  linkQualityHistogram () {
    const bins = this.linkQualityHistogramBins();
    var lq = [];
    if (Array.isArray(this.props?.data)) {
      this.props.data.forEach(row => lq.push(nestedProp(row, "LatestLinkStatusData.LinkQuality")))
      return histogram (lq, bins);
    }
    return null;
  }
  onClick (param) {
    if (param.length) {  // apply filter
      const [{index}] = param
      this.props?.histoFilter && this.props.histoFilter (this.bins, index) 
    }
    else {     //clear filter
      this.props?.histoFilter && this.props.histoFilter (this.bins, -1) 
    }
  }

  render() {
    const gram = this.linkQualityHistogram()
    let bins = this.linkQualityHistogramBins()
    let hcolors = this.linkQualityHistogramColors()
    if (gram && gram.length > bins.length) {
      bins.unshift('NA')
      hcolors.unshift('#808080')
    }
    this.bins = bins

    return (
      <div className="histogram-single">
      <div className="histogram-title">{this.props.title}Link Quality at a Glance</div>
      <HistogramPanel {...this.props}  series1={gram} 
            label={bins} colors={hcolors} onClick={this.onClick}/>
      </div>
    )
  }
}